<template>
  <div>
    <div class="title">乘客须知</div>
    <el-divider id="bottom-divider"></el-divider>
    <el-collapse>
      <el-collapse-item title="退票" name="1">
        <div>
          在官网中，登陆后点击个人信息，点击我的订单，即可退票；一个月内退票两次会影响您的信用等级，
          当您的信用等级过低时，您就无法再购买票。
        </div>
      </el-collapse-item>
      <el-collapse-item title="限制运输人员" name="2">
        <div>
          婴儿、无成人陪伴儿童、患病旅客、残疾人旅客、孕妇或犯人（含犯罪嫌疑人）等特殊旅客，只有在符合东航及其有
          关承运人规定的条件下，经本航空公司及其有关承运人预先同意并在必要时做出安排后予以承运。
        </div>
      </el-collapse-item>
      <el-collapse-item title="限制运输物品" name="3">
        <div>
          精密仪器、电器、体育运动用器械，旅客旅行中使用的折叠轮椅、电动轮椅等，以及导盲犬、助听犬、小动物（限家庭驯养的宠物狗、宠物猫、宠物鸟）、干冰、含有酒精的饮料，
          上述物品只有在符合我们运输条件,并经我们同意后方可运输。
        </div>
      </el-collapse-item>
      <el-collapse-item title="行李包装" name="4">
        <div>
          您的托运行李应包装完善、锁扣完好、捆扎牢固，能承受一定的压力，能够在正常的操作条件下安全装卸和运输。
          对包装不符合要求的行李，我们可拒绝收运或不承担损坏、破损的赔偿责任。
        </div>
      </el-collapse-item>
      <el-collapse-item title="行李赔偿责任" name="5">
        <div>
          我们对国内运输的托运行李赔偿的最高限额为每千克100元人民币；非托运行李每名旅客赔偿最高限额为3000元人民币。
          如您的行李的实际损失低于限额标准，按实际损失赔偿。对于无法计算重量的托运行李，我们按您客票舱位等级规定的免费行李额计算。我们对行李的赔偿，仅限于经证实的损失和费用。
          对于办理了声明价值的行李发生损失，我们按声明价值规定赔偿。有关行李赔偿的具体规定请向我们查询。
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<style lang="scss" scoped>
@import '@/assets/css/config.scss';
.title {
  margin-top: 10%;
  line-height: 30px;
  font-weight: 600;
  font-size: 20px;
  color: $themeLight;
}
#bottom-divider {
  margin-top: 30px;
  height: 0.07px;
  line-height: 0.07px;
}
* {
  line-height: 25px;
}
.el-collapse-item div {
  text-align: left;
  text-indent: 2em;
}
:deep(.el-collapse-item__header) {
  font-size: 14px;
  // color: $themeLight;
}
:deep(.el-collapse-item__header.is-active) {
  font-size: 16px;
  font-weight: 600;
  color: $themeColor;
}
</style>
